import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';

import { AngularFirestore, DocumentReference } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';

import { auth, firestore } from 'firebase/app';
import AuthProvider = firebase.auth.AuthProvider;
import { User } from '../../interfaces/user';

import { switchMap, take } from 'rxjs/operators';
import { UsersService } from '../users/users.service';
import { EventsService } from '../events/events.service';
import { CreatedInfo } from 'src/app/interfaces/helpers';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public user: firebase.User;
  public userRef: DocumentReference;

  user$: Observable<any>;
  // public device: DeviceInfo = null;

  currentUser: BehaviorSubject<User> = new BehaviorSubject(null);
  userStore: User = null;
  constructor(
    private afs: AngularFirestore,
    public afAuth: AngularFireAuth,
    public usersServ: UsersService,
    public eventsServ: EventsService
  ) {
    this.user$ = this.afAuth.authState.pipe(
      take(1),
      switchMap(user => {
        // debugger;
        // console.log(user);
        if (user) {
          this.user = user;
          this.userStore = user;
          this.userRef = this.afs.firestore.collection('users').doc(this.user.uid);
          return usersServ.getUser(this.user.uid);
        } else {
          return of(null);
        }
      })
    );
    afAuth.authState.subscribe(user => {
      // console.log(user);
      if (user) {
        this.user = user;
        this.userRef = this.afs.firestore.collection('users').doc(this.user.uid);
        usersServ.getUser(this.user.uid).subscribe(u => {
          // console.log(u);
          this.userStore = u;
          this.currentUser.next(u);
          this.eventsServ.nextUserPublish('login');
          // console.log(this.currentUser);
        });
      }
    });
  }

  hasRoles(roles: string[]): boolean {
    let access = false;
    // console.log(roles);
    if (roles === undefined) {
      return false;
    }
    if (roles.length === 0) {
      return true;
    }
    // console.log(this.currentUser);
    // console.log(this.currentUser.value);
    // console.log(this.currentUser.getValue());

    // console.log(this.currentUser['_value']);
    for (const oneRole of roles) {
      if (this.currentUser && this.currentUser.getValue() && this.currentUser.getValue().roles) {
        // console.log('Roles user', this.currentUser.getValue().roles);
        Object.keys(this.currentUser.getValue().roles).map(m => {
          if (m === oneRole) {
            if (this.currentUser.getValue().roles[m] === true) {
              access = true;
              return access;
            }
          }
        });
      }
    }
    return access;
  }

  getUserSubject() {
    return this.currentUser.asObservable();
  }

  signInWithEmail(credentials) {
    //  // console.log('Sign in with email');
    // this.afAuth.languageCode = 'es';
    return this.afAuth.signInWithEmailAndPassword(credentials.email, credentials.password);
  }

  signUp(credentials) {
    return this.afAuth.createUserWithEmailAndPassword(credentials.email, credentials.password);
  }

  setUser(user) {
    this.user = user;
  }

  getAuthenticated(): Observable<firebase.User> {
    return this.user$;
  }

  get authenticated(): boolean {
    return this.currentUser !== null;
  }

  get getEmail() {
    return this.user.email;
  }

  get getDisplayName(): string {
    return this.user.displayName || this.currentUser.value.displayName;
  }

  get getUser() {
    return this.user;
  }

  get getUserUID() {
    return this.user.uid;
  }

  signOut(): Promise<void> {
    //  // console.log('sign out');
    this.user = null;
    return this.afAuth.signOut();
  }

  signInWithGoogle() {
    //  // console.log('Sign in with google');
    return this.oauthSignIn(new auth.GoogleAuthProvider());
  }

  signInWithFacebook() {
    //  // console.log('Sign in with facebook');
    return this.oauthSignIn(new auth.FacebookAuthProvider());
  }

  private oauthSignIn(provider: AuthProvider) {
    if (!(window as any).cordova) {
      return this.afAuth.signInWithPopup(provider);
    } else {
      return this.afAuth.signInWithRedirect(provider).then(() => {
        return this.afAuth
          .getRedirectResult()
          .then(result => {
            // This gives you a Google Access Token.
            // You can use it to access the Google API.
            const token = result.credential.providerId;
            // The signed-in user info.
            const user = result.user;
            //  // console.log(token, user);
          })
          .catch(error => {
            // Handle Errors here.
            alert(error.message);
          });
      });
    }
  }

  forgetPass(emailAddress: string): Promise<void> {
    return this.afAuth.sendPasswordResetEmail(emailAddress);
  }

  getCreatedInfo(): CreatedInfo {
    return {
      user: { name: this.getDisplayName, ref: this.userRef },
      ts: firestore.Timestamp.fromDate(new Date()),
    };
  }
}
